import { render, staticRenderFns } from "./BienvenueAltEditor.vue?vue&type=template&id=27cd8850"
import script from "./BienvenueAltEditor.vue?vue&type=script&lang=js"
export * from "./BienvenueAltEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports